import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import StaffComponent from "../components/staff/StaffComponent";

const StaffPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Staff"
        routes={[{ title: "Home", path: "/" }]}
      />
      <StaffComponent />
    </>
  );
};
export default StaffPage;
